/** Selected tag chips and inline add field for TaskForm tags. */
import { Box, Chip } from '@mui/material';
import TagChip from '@/components/ui/TagChip';
import { TaskFormTagInlineAddField } from '@/features/tasks/components/forms/fields/TaskFormTagInlineAddField';
import { useT } from '@/i18n/useT';
import {
  PARENT_CHIP_FONT_WEIGHT_ROOT,
  PARENT_CHIP_FONT_WEIGHT_SELECTED,
} from '@/features/tasks/components/forms/fields/taskFormTagSectionConstants';

export function TaskFormTagChips({
  task,
  projectDisplayMap,
  contextDisplayMap,
  removeProject,
  removeContext,
  handlePersonChange,
  parentLabel,
  onOpenParentEditor,
  inlineAddKind,
  inlineDraft,
  setInlineDraft,
  inlineOptions,
  inlinePlaceholder,
  commitInlineAdd,
  cancelInlineAdd,
  addTagChipRef,
  onOpenAddMenu,
}) {
  const t = useT();
  const parentChipFontWeight = task.parentId
    ? PARENT_CHIP_FONT_WEIGHT_SELECTED
    : PARENT_CHIP_FONT_WEIGHT_ROOT;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.75,
        alignItems: 'center',
      }}
    >
      {(task.projects || []).map((project) => (
        <TagChip
          key={`p-${project}`}
          tag={project}
          label={
            projectDisplayMap.get(String(project).toLowerCase()) || project
          }
          onDelete={() => removeProject(project)}
          truncateToContainer
        />
      ))}
      {(task.contexts || []).map((context) => (
        <TagChip
          key={`c-${context}`}
          tag={`@${context}`}
          label={
            contextDisplayMap.get(String(context).toLowerCase()) || context
          }
          onDelete={() => removeContext(context)}
          truncateToContainer
        />
      ))}
      {task.person ? (
        <TagChip
          key={`person-${task.person}`}
          tag={task.person}
          label={task.person}
          onDelete={() => handlePersonChange(null, null)}
          truncateToContainer
        />
      ) : null}
      <Chip
        label={parentLabel}
        title={
          task.parentId
            ? undefined
            : t(
                'taskform.rootParentHint',
                'Deze taak heeft geen bovenliggende taak.',
              )
        }
        size="small"
        variant="outlined"
        onClick={onOpenParentEditor}
        data-testid="task-form-parent-chip"
        sx={{
          fontWeight: parentChipFontWeight,
          color: task.parentId ? 'text.primary' : 'text.secondary',
          borderStyle: task.parentId ? 'solid' : 'dashed',
        }}
      />
      <TaskFormTagInlineAddField
        inlineAddKind={inlineAddKind}
        inlineDraft={inlineDraft}
        setInlineDraft={setInlineDraft}
        inlineOptions={inlineOptions}
        inlinePlaceholder={inlinePlaceholder}
        commitInlineAdd={commitInlineAdd}
        cancelInlineAdd={cancelInlineAdd}
      />
      <Chip
        ref={addTagChipRef}
        label={t('taskform.addTag', '+ toevoegen')}
        size="small"
        variant="outlined"
        onClick={onOpenAddMenu}
        data-testid="task-form-add-tag-chip"
        sx={{ borderStyle: 'dashed', color: 'text.subtle' }}
      />
    </Box>
  );
}
